import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FileService} from '../services/file.service';
import {FileAttachment} from '../model/file-attachment.model';
import {UntypedFormBuilder, UntypedFormGroup, Validators,AbstractControl} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import remove from 'lodash-es/remove';
import { FileDownloadHandler, SessionService } from '@edl-development/edl-common';

@Component({
    selector: 'edl-evidence-modal',
    templateUrl: './edl-evidence-modal.component.html',
    styleUrls: ['./edl-evidence-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EdlModalEvidence implements OnInit {
    @Input() fileType: number;
    @Input() fileTypeId: string;
    @Input() isReadOnly: boolean = false;
    @Input() isDeleteDisabled: boolean = false;
    @Input() canClose: Boolean = true;


    @Output() onSubmissionComplete = new EventEmitter<{ success: boolean, files: Array<FileAttachment> }>();

    form: UntypedFormGroup;
    files: Array<FileAttachment>;
    fileList: FileList;


    constructor(
        private fileService: FileService,
        public activeModal: NgbActiveModal,
        private sessionService: SessionService,
        private formBuilder: UntypedFormBuilder,
        private toastr: ToastrService,
        private fileHandler: FileDownloadHandler
    ) {}

    ngOnInit() {

        this.fileService
            .getFilesForItem(this.fileType, this.fileTypeId)
            .subscribe((result: Array<FileAttachment>) => {
                this.files = result;
            });

            this.buildForm();
    }

    buildForm() {
        this.form = this.formBuilder.group({
            FileID: [null, []],
            FileName: [null, [Validators.required]],
            DisplayName: [null, []],
            FileSize: [null, []],
            FileType: [null, []],
            UserID: [this.sessionService.user.UserID, []],
            PortalID: [this.sessionService.user.UserPortal.PortalID, []],
            UploadBy: [this.sessionService.user.UserID, []],
            UploadByDisplayName: [this.sessionService.user.DisplayName, []],
            UploadDate: [null, []]
        });  
    }

    onChange(event) {
        let filename = '';

        try {
            filename = event.srcElement.value;
        }
        catch(e) {
            filename = event.target.value;
        }

        this.form.get('FileName').setValue(filename.replace('C:\\fakepath\\', ''));
        this.fileList = event.target.files;
    }

    submit({ value, valid }: { value: FileAttachment, valid: boolean}) {
        if (valid) {
            let displayBox: AbstractControl = this.form.get('DisplayName');
            let display = displayBox.value;
            this.fileService
                .uploadFile({ fileList: this.fileList, type: this.fileType, typeId: this.fileTypeId, portalId: value.PortalID, fileId: null, displayName: display })
                .subscribe((result: FileAttachment) => {
                    this.files.push(result);
                    this.toastr.success('Evidence uploaded successfully.');

                    this.buildForm();

                    this.onSubmissionComplete.emit({ success: true, files: this.files });
                }, () => {
                    this.toastr.error('Error uploading evidence.');
                });
        }
    }

    icon(filename: string): string {
        let parts: Array<string> = filename.split('.');
        let fileExtension: string = parts.pop();

        let css: string = '';

        switch (fileExtension) {
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'png':
            case 'tiff':
                css = 'far fa-file-image';
                break;

            case 'xls':
            case 'xlsx':
                css = 'far fa-file-excel';
                break;

            case 'doc':
            case 'docx':
                css = 'far fa-file-word';
                break;

            case 'pdf':
                css = 'far fa-file-pdf';
                break;

            case 'txt':
            case 'csv':
            case 'rtf':
                css = 'far fa-file-alt';
                break;

            case 'zip':
                css = 'far fa-file-archive';
                break;

            case 'ppt':
            case 'pptx':
                css = 'fas fa-powerpoint-o';
                break;

            case 'm4a':
            case 'mp3':
            case 'mp4':
            case 'wav':
            case 'aac':
                css = 'far fa-file-audio';
                break;

            default:
                css = 'far fa-file';
                break;
        }

        return css;
    }

    viewEvidence(attachment: FileAttachment) {
        this.fileService
            .getFileResponse(attachment.FileID)
            .subscribe((fileResponse : Blob) => {
                this.fileHandler.saveFile(fileResponse, attachment.FileName);
            });
    }

    deleteEvidence(attachment: FileAttachment) {
        this.fileService
            .deleteFile(attachment)
            .subscribe(() => {
                remove(this.files, { FileID: attachment.FileID });
                this.toastr.success('Evidence deleted successfully.');

                this.onSubmissionComplete.emit({ success: true, files: this.files });
            }, () => {
                this.toastr.error('Error deleting evidence.');
            });
    }

    canDelete = (file: FileAttachment) => {
        return !this.isReadOnly && !this.isDeleteDisabled && file.UserID === this.sessionService.user.UserID;
    }
}